import React from 'react'
import { Modal, Stack } from '~/components/_layouts'
import { UserIcon } from '@heroicons/react/24/outline'
import { useCoachDashboard } from '../CoachDashboardProvider'

const ColorKeyDialog = () => {
  const { showColorKeyDialog, toggleShowColorKeyDialog } = useCoachDashboard()
  return (
    <Modal
      title={
        <Stack direction="row" spacing={2}>
          <UserIcon className="h-6 w-6" />
          Coach Live Events Color Code Key
        </Stack>
      }
      variant="secondary"
      size="md"
      open={showColorKeyDialog}
      onClose={() => toggleShowColorKeyDialog()}
    >
      <table className="mx-auto">
        <tbody>
          <tr className="py-2">
            <td>Blue:</td>
            <td className="ml-2 bg-[#167bd7] px-4 py-2 text-white">
              Requested
            </td>
          </tr>
          <tr>
            <td className="h-1"></td>
          </tr>
          <tr className="py-2">
            <td>Yellow:</td>
            <td className="ml-2 bg-[#ecb90d] px-4 py-2 text-white">
              Tentative
            </td>
          </tr>
          <tr>
            <td className="h-1"></td>
          </tr>
          <tr className="py-2">
            <td>Green:</td>
            <td className="ml-2 bg-[#5caa5c] px-4 py-2 text-white">
              Confirmed
            </td>
          </tr>
          <tr>
            <td className="h-1"></td>
          </tr>
          <tr className="py-2">
            <td>Red:</td>
            <td className="ml-2 bg-[#ff4343] px-4 py-2 text-white">
              Cancelled
            </td>
          </tr>
          <tr>
            <td className="h-1"></td>
          </tr>
          <tr className="py-2">
            <td>Black:</td>
            <td className="ml-2 bg-[#3c3f45] px-4 py-2 text-white">
              Completed in the past
            </td>
          </tr>
        </tbody>
      </table>

      <br />
      <br />
      <table className="mx-auto">
        <tbody>
          <tr className="py-2">
            <td className="w-[75px] pr-2">Webinar:</td>
            <td className="border-4 border-orange-500 px-4 py-2"></td>
            <td className="w-5"></td>
            <td className="w-[75px] pr-2">Workshop:</td>
            <td className="border-4 border-purple-500 px-4 py-2"></td>
            <td className="w-5"></td>
            <td className="w-[75px] pr-2">Roundtable:</td>
            <td className="border-4 border-teal-500 px-4 py-2"></td>
          </tr>
        </tbody>
      </table>
    </Modal>
  )
}

export default ColorKeyDialog
